export const ANNOTATION_BORDER_COLOR_RGB = [221, 214, 254, 1] as const
export const ANNOTATION_FILL_COLOR_RGB = [245, 243, 255, 0.2] as const
export const ANNOTATION_SELECTED_BORDER_COLOR_RGB = [129, 107, 237, 1] as const
export const ANNOTATION_SELECTED_FILL_COLOR_RGB = [213, 207, 243, 0.4] as const
